<template>
    <div class="page_wrap">
        <!-- 认证新企业（复用 NotCertified.vue 流程） -->
        <Modal
            v-model="showNewEnterpriseCert"
            :mask-closable="true"
            footer-hide
            width="960"
            class-name="new-enterprise-cert-modal" 
            @on-cancel="closeNewEnterpriseCert"
        >
            <NotCertified
                ref="notCertifiedRef" 
                certScene="newEnterprise"
                @refresh="handleNotCertifiedRefresh"
                @back="closeNewEnterpriseCert"
            />
        </Modal>

        <!-- 认证中企业列表 -->
        <Modal
            v-model="showWaitCertModal"
            :mask-closable="true"
            footer-hide
            width="1000"
            title="认证中企业列表"
            class-name="wait-cert-list-modal"
            @on-cancel="closeWaitCertModal"
        >
            <div class="wait-cert-modal-content">
                <div v-if="waitCertLoading" class="loading-wrapper">
                    <Icon type="ios-loading" size="24" class="loading-icon"></Icon>
                    <span>加载中...</span>
                </div>
                <div  v-else style="max-height: 400px;overflow-y: auto;">
                    <Table 
                        :columns="waitCertColumns"
                        :data="waitCertList"
                        :loading="waitCertLoading"
                    >
                        <template slot-scope="{ row }" slot="action">
                            <Button type="primary" size="small" @click="handleWaitCertDetail(row)">
                                详情
                            </Button>
                        </template>
                    </Table>
                </div>

                <div class="pagination-wrapper" 
                    style="margin-top: 20px;padding-bottom: 20px;display: flex;justify-content: flex-end;" 
                    v-if="waitCertTotal > 0 && !waitCertLoading">
                    <Page
                        :total="waitCertTotal"
                        :current="waitCertPage"
                        :page-size="waitCertPageSize"
                        @on-change="handleWaitCertPageChange"
                        show-elevator
                        show-total
                    />
                </div>
            </div>
        </Modal>
        <div class="content-layout">
            <!-- 左侧：企业信息卡片 -->
            <div class="left-card">
                <div class="enterprise-card">
                    <div class="card-header">
                        <div class="card-title">
                            <Select

                                v-model="enterpriseAuthId"
                                class="enterprise-switch-select"
                                placeholder="企业名称"
                                style="width: 350px;margin-left: -8px;"
                                :disabled="enterpriseSwitchLoading || enterpriseList.length === 0"
                                @on-change="handleEnterpriseChange"
                            >
                                <Option
                                    v-for="item in enterpriseList"
                                    :key="item.id"
                                    :value="item.id" 
                                >
                                    {{ item.prise_name }}
                                </Option>
                            </Select> 
                        </div>
                        <div class="setting-icon" @click="showSettingMenu = !showSettingMenu" ref="settingIcon">
                            <img src="@/assets/imgs/shezhi.png" alt="设置" />
                            <div class="setting-menu" v-show="showSettingMenu">
                                <template v-if="enterpriseInfo.is_member === 0">
                                    <div class="menu-item" @click="handleMenuClick('auth')">授权中心</div>
                                    <div class="menu-item" @click="handleMenuClick('change')">企业信息变更</div> 
                                    <div class="menu-item" @click="handleMenuClick('newEnterpriseCert')">认证新企业</div>
                                    <div class="menu-item" @click="handleMenuClick('waitCert')">认证中企业列表</div>
                                    <div class="menu-item" @click="handleMenuClick('record')">变更记录</div>
                                    <div class="menu-item" @click="handleMenuClick('exit')">申请退出该企业</div>
                                    <div class="menu-item" @click="handleMenuClick('cancel')">注销组织账号</div>
                                    <div class="menu-item" @click="handleMenuClick('exitNotice')">申请退出通知</div>
                                </template>
                                <template v-else>
                                    <div class="menu-item" @click="handleMenuClick('exit')">申请退出该企业</div>
                                    <div class="menu-item" @click="handleMenuClick('exitNotice')">申请退出通知</div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="info-row">
                            <span class="info-label">统一社会信用代码：</span>
                            <span class="info-value">{{ enterpriseInfo.license_register || '--' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">法定代表人：</span>
                            <span class="info-value">{{ enterpriseInfo.legal_person || '--' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧：统计卡片 -->
            <div class="right-cards">
                <div class="stat-card">
                    <div class="stat-label">成员人数</div>
                    <div class="stat-value">{{ memberCount }}人</div>
                </div>
                <div class="stat-card">
                    <div class="stat-label">电子章</div>
                    <div class="stat-value">{{ sealCount }}个</div>
                </div>
            </div>
        </div>

        <!-- 底部：用印统计图表 -->
        <div class="chart-card">
            <div class="chart-header">
                <div class="chart-title">用印统计(共{{ totalUsage }}次)</div>
                <div class="chart-controls">
                    <div class="time-selector">
                        <span 
                            v-for="item in timeOptions" 
                            :key="item.value"
                            :class="['time-option', { active: selectedTime === item.value }]"
                            @click="selectTime(item.value)"
                        >
                            {{ item.label }}
                        </span>
                    </div>
                    <div class="date-range">
                        <DatePicker
                            type="daterange"
                            v-model="dateRangeValue"
                            format="yyyy-MM-dd"
                            placeholder="选择日期范围"
                            @on-change="handleDateChange"
                            style="width: 240px"
                        >
                            <Icon type="ios-calendar-outline" slot="prefix" />
                        </DatePicker>
                    </div>
                </div>
            </div>
            <div class="chart-container">
                <div id="sealUsageChart" :style="{ width: '100%', height: '400px' }"></div>
            </div>
        </div>

        <!-- 注销组织弹窗 -->
        <Modal
            v-model="showCancelModal"
            :mask-closable="false"
            title="注销组织"
            width="800"
            class-name="cancel-org-modal"
            @on-cancel="closeCancelModal"
        >
            <div class="cancel-modal-content">
                <div class="warning-header" style="display: flex;justify-content: center;">
                    <div class="warning-title">
                        <Icon type="ios-warning" class="warning-icon" />
                    </div>
                </div>
                <div class="warning-header" style="display: flex;justify-content: center;">
                    <div class="warning-title">
                        您即将注销组织<span class="company-name">[{{ enterpriseInfo.company_name || '企业名称' }}]</span>
                    </div>
                </div>
                <div class="warning-subtitle" style="display: flex;justify-content: center;">
                    注销后,相关组织账号将无法登录,文件、印章、证书等数据将被删除
                </div>
                
                <div class="consequences-list">
                    <div class="consequence-item">
                        <div class="consequence-title">文件将被删除/无法访问</div>
                        <div class="consequence-desc">
                            当前组织发起和签署的文件，以及共同签署的文件将被删除且无法访问，请及时下载备份相关文件。
                        </div>
                    </div>
                    <div class="divider"></div>
                    
                    <div class="consequence-item">
                        <div class="consequence-title">组织印章、认证信息将被删除</div>
                        <div class="consequence-desc">
                            组织印章、法人签名、认证授权信息将被删除且无法恢复。
                        </div>
                    </div>
                    <div class="divider"></div>
                    
                    <div class="consequence-item">
                        <div class="consequence-title">组织内成员将自动离职</div>
                        <div class="consequence-desc">
                            组织内所有成员将自动从当前组织离职。
                        </div>
                    </div>
                    <!-- <div class="divider"></div> -->
                    
                    <!-- <div class="consequence-item">
                        <div class="consequence-title">授权记录将自动取消</div>
                        <div class="consequence-desc">
                            第三方静默签署、第三方登录授权将自动取消。
                        </div>
                    </div> -->
                </div>

                <div class="agreement-checkbox">
                    <Checkbox v-model="agreedToCancel">
                        <span>已阅读并同意</span>
                        <a href="#" @click.prevent="viewAgreement" class="agreement-link">《注销协议》</a>
                    </Checkbox>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="closeCancelModal" class="cancel-btn" :disabled="cancelSubmitting">取消</Button>
                <Button 
                    type="primary" 
                    @click="confirmCancel" 
                    :loading="cancelSubmitting"
                    :disabled="!agreedToCancel || cancelSubmitting"
                    class="confirm-btn"
                >
                    确定
                </Button>
            </div>
        </Modal>

        <!-- 申请退出企业弹窗 -->
        <Modal
            v-model="showExitModal"
            :mask-closable="false"
            title="申请退出企业"
            width="600"
            class-name="exit-enterprise-modal"
            @on-cancel="closeExitModal"
        >
            <div class="exit-modal-content">
                <div class="exit-instruction">
                    您正在申请退出<span class="company-name">【{{ enterpriseInfo.company_name || '企业名称' }}】</span>，请填写理由：
                </div>
                <div class="exit-reason-input">
                    <Input
                        v-model="exitReason"
                        type="textarea"
                        :rows="6"
                        placeholder="请输入退出理由"
                        :maxlength="500"
                        show-word-limit
                    />
                </div>
            </div>
            <div slot="footer" class="exit-modal-footer">
                <Button @click="closeExitModal" class="cancel-btn">取消</Button>
                <Button 
                    type="primary" 
                    @click="confirmExit" 
                    :loading="exitSubmitting"
                    :disabled="exitSubmitting || !exitReason || exitReason.trim() === ''"
                    class="confirm-btn"
                >
                    确定
                </Button>
            </div>
        </Modal>

        <!-- 变更记录弹窗 -->
        <Modal
            v-model="showRecordModal"
            :mask-closable="false"
            title="企业信息变更记录"
            width="900"
            class-name="change-record-modal"
            :footer-hide="true"
            @on-cancel="closeRecordModal"
        >
            <div class="record-modal-content">
                <div v-if="changeRecordsLoading" class="loading-wrapper">
                    <Icon type="ios-loading" size="24" class="loading-icon"></Icon>
                    <span>加载中...</span>
                </div>
                <div v-else-if="changeRecords.length === 0" class="empty-record">
                    <Icon type="ios-document-outline" size="48" />
                    <div class="empty-text">暂无变更记录</div>
                </div>
                <div v-else class="record-list">
                    <div 
                        v-for="(record, index) in changeRecords" 
                        :key="record.id || index"
                        class="record-item"
                    >
                        <div class="record-header">
                            <div class="record-time">{{ record.created_at || record.updated_at || '--' }}</div>
                            <div class="record-operator">
                                {{ record.operator_name || record.real_name || '--' }} 
                                <span v-if="record.enterprise_auth && record.enterprise_auth.phone">
                                    ({{ formatPhone(record.enterprise_auth.phone) }})
                                </span>
                            </div>
                            <div class="record-type">{{ record.enterprise_auth && record.enterprise_auth.status === 1 ? '企业认证' : '待认证' }}</div>
                        </div>
                        <div class="record-details">
                            <div class="detail-item">
                                <span class="detail-label">企业名称：</span>
                                <span class="detail-value">
                                    <template v-if="record.old_prise_name && record.old_prise_name !== record.prise_name">
                                        <span class="old-value">{{ record.old_prise_name }}</span>
                                        <span class="separator"> / </span>
                                    </template>
                                    <span>{{ record.prise_name || '--' }}</span>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">统一社会信用代码：</span>
                                <span class="detail-value">{{ enterpriseInfo.license_register|| '--' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">法定代表人：</span>
                                <span class="detail-value">
                                    <template v-if="record.old_real_name && record.old_real_name !== record.real_name">
                                        <span class="old-value">{{ record.old_real_name }}</span>
                                        <span class="separator"> / </span>
                                    </template>
                                    <span>{{ record.real_name || '--' }}</span>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">法人身份证：</span>
                                <span class="detail-value">
                                    <template v-if="record.old_id_card && record.old_id_card !== record.id_card">
                                        <span class="old-value">{{ record.old_id_card }}</span>
                                        <span class="separator"> / </span>
                                    </template>
                                    <span>{{ record.id_card || '--' }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="changeRecordTotal > 0 && !changeRecordsLoading">
                    <Page
                        :total="changeRecordTotal"
                        :current="changeRecordPage"
                        :page-size="changeRecordPageSize"
                        @on-change="changeRecordPageHandler"
                        show-elevator
                        show-total
                    />
                </div>
            </div>
            <div slot="footer" class="record-modal-footer">
                <Button @click="closeRecordModal" type="primary" class="close-btn">关闭</Button>
            </div>
        </Modal>

        <!-- 授权中心弹窗 -->
        <Modal
            v-model="showAuthModal"
            :mask-closable="false"
            title="认证授权中心"
            width="900"
            class-name="auth-center-modal"
            @on-cancel="closeAuthModal"
            :footer-hide="true"
        >
            <div class="auth-modal-content">
                <div class="enterprise-info-section">
                    <div class="section-title">{{ enterpriseInfo.company_name || '--' }}</div>
                    <div class="info-details">
                        <div class="info-line">
                            <span class="info-label">统一社会信用代码：</span>
                            <span class="info-value">{{ enterpriseInfo.license_register || '--' }}</span>
                        </div>
                        <div class="info-line">
                            <span class="info-label">法定代表人：</span>
                            <span class="info-value">{{ enterpriseInfo.legal_person || '--' }}</span>
                        </div>
                    </div>
                </div>

                <div class="auth-records-section">
                    <div class="section-title">认证授权记录</div>
                    <Table :columns="authColumns" :data="authRecords" :loading="authLoading">
                        <template slot-scope="{ row }" slot="action">
                            <Button type="error" size="small" v-if="row.status === 1" @click="cancelAuth(row)">取消授权</Button>
                        </template>
                    </Table>
                    <div class="pagination-wrapper" v-if="authTotal > 0">
                        <Page
                            :total="authTotal"
                            :current="authPage"
                            :page-size="authPageSize"
                            @on-change="changeAuthPage"
                            show-elevator
                            show-total
                        />
                    </div>
                </div>
            </div>
            <div slot="footer" class="record-modal-footer"> 
            </div>
        </Modal>

        <!-- 企业信息变更提示弹窗 -->
        <Modal
            v-model="showChangeTipModal"
            :mask-closable="false"
            title="提示"
            width="500"
            class-name="change-tip-modal"
            @on-cancel="closeChangeTipModal"
        >
            <div class="tip-modal-content">
                <div class="tip-icon-wrapper">
                    <Icon type="ios-warning" class="tip-icon" />
                </div>
                <div class="tip-content">
                    <div class="tip-item">1. 若变更企业名称,变更成功后请联系印章管理员重新制作印章</div>
                    <div class="tip-item">2. 若变更法定代表人,变更成功后请前往角色与权限中更新成员</div>
                </div>
            </div>
            <div slot="footer" class="tip-modal-footer">
                <Button @click="closeChangeTipModal" class="cancel-btn">取消</Button>
                <Button type="primary" @click="confirmChangeTip" class="confirm-btn">下一步</Button>
            </div>
        </Modal>

        <!-- 企业信息变更表单弹窗 -->
        <Modal
            v-model="showChangeFormModal"
            :mask-closable="false"
            title="企业信息变更"
            width="760"
            class-name="change-form-modal"
            @on-cancel="closeChangeFormModal"
        >
            <div class="auth-form-content">
                <!-- 组织类型 -->
                <div class="form-section">
                    <div class="section-title">组织类型</div>
                    <div class="option-group">
                        <div 
                            class="option-item" 
                            :class="{ active: changeForm.orgType === 'enterprise' }"
                            @click="changeForm.orgType = 'enterprise'"
                        >
                            企业
                        </div>
                        <div 
                            class="option-item" 
                            :class="{ active: changeForm.orgType === 'individual' }"
                            @click="changeForm.orgType = 'individual'"
                        >
                            个体工商户
                        </div>
                    </div>
                </div>

                <!-- 认证方式 -->
                <div class="form-section">
                    <div class="section-title">认证方式</div>
                    <div class="option-group">
                        <div 
                            class="option-item" 
                            :class="{ active: changeForm.authMethod === 'legal' }"
                            @click="changeForm.authMethod = 'legal'"
                        >
                            法定代表人
                        </div>
                    </div>
                </div>

                <!-- 填写组织信息 -->
                <div class="form-section">
                    <div class="section-title">填写组织信息</div>
                    <Form ref="changeForm" :model="changeForm" :rules="changeFormRules" :label-width="140">
                        <!-- 营业执照 -->
                        <FormItem v-if="showLicense" label="营业执照:" prop="license"> 
                            <div class="license-upload-wrap">
                                <div class="license-left">
                                    <div v-if="changeLicenseOcrLoading" class="license-ocr-loading">
                                        <div class="dots"><span></span><span></span><span></span></div>
                                        <div class="txt">识别中...</div>
                                    </div>
                                    <div v-if="changeForm.license" class="license-preview">
                                        <img class="license-img" :src="changeForm.license" alt="营业执照" @error="handleImageError" />
                                        <div class="license-actions">
                                            <Upload
                                                :show-upload-list="false"
                                                :headers="headers"
                                                :action="licenseOcrAction"
                                                :format="['jpg', 'jpeg', 'png']"
                                                :before-upload="beforeChangeLicenseOcrUpload"
                                                :on-success="onChangeLicenseUploadSuccess"
                                                :on-error="onChangeLicenseOcrError"
                                                :on-format-error="onLicenseFormatError"
                                            >
                                                <Button size="small" type="primary" :disabled="changeLicenseOcrLoading">重新上传</Button>
                                            </Upload>
                                            <Button size="small" style="margin-left: 8px" :disabled="changeLicenseOcrLoading" @click="previewChangeLicense">预览</Button>
                                            <Button size="small" style="margin-left: 8px" type="error" ghost :disabled="changeLicenseOcrLoading" @click="removeChangeLicense">删除</Button>
                                        </div>
                                    </div>
                                    <div v-else class="license-empty">
                                        <Upload
                                            :show-upload-list="false"
                                            :headers="headers"
                                            :action="licenseOcrAction"
                                            :format="['jpg', 'jpeg', 'png']"
                                            :before-upload="beforeChangeLicenseOcrUpload"
                                            :on-success="onChangeLicenseUploadSuccess"
                                            :on-error="onChangeLicenseOcrError"
                                            :on-format-error="onLicenseFormatError"
                                            :disabled="changeLicenseOcrLoading"
                                        >
                                            <div class="license-uploader">
                                                <div class="plus">+</div>
                                                <div class="tips">点击上传</div>
                                            </div>
                                        </Upload>
                                    </div>
                                </div>
                                <div class="license-right">
                                    <a class="license-example" href="#" @click.prevent="openLicenseExample">示例</a>
                                    <div class="license-desc">请上传彩色原件或加盖公司公章的复印件</div>
                                </div>
                            </div>
                        </FormItem>
                        <FormItem label="组织机构名称:" prop="orgName">
                            <Input 
                                v-model="changeForm.orgName" 
                                placeholder="请输入组织机构名称"
                                :maxlength="100"
                                style="width: 300px;"
                                :readonly="changeOrgNameLocked"
                                :disabled="changeOrgNameLocked"
                                :class="{ 'locked-input': changeOrgNameLocked }"
                                @on-change="clearChangeExistCheck"
                                @on-blur="handleChangeOrgNameBlur"
                            />
                        </FormItem>
                        <div v-if="changeExistCheck.isExist && changeExistCheck.msg" class="exist-tip" 
                            style="margin-left: 140px;margin-top: -20px;color: #ed4014;">
                            {{ changeExistCheck.msg }}
                        </div>
                        <FormItem label="统一社会信用代码:" prop="licenseCode">
                            <!-- :readonly="!!changeForm.license" -->
                                <!-- :disabled="!!changeForm.license" -->
                            <Input 
                                v-model="changeForm.licenseCode" 
                                readonly
                                disabled
                                placeholder="请输入统一社会信用代码" 
                                style="width: 300px;"
                            />
                        </FormItem>
                        <FormItem label="法定代表人:" prop="legalPerson">
                            <Input 
                                v-model="changeForm.legalPerson" 
                                placeholder="请输入法人代表人名称"
                                :maxlength="50"
                                style="width: 300px;"
                            />
                        </FormItem>
                        <FormItem label="法人身份证:" prop="legalPerson">
                            <Input 
                                v-model="changeForm.id_card" 
                                placeholder="请输入法人身份证"
                                :maxlength="50"
                                style="width: 300px;"
                            />
                        </FormItem>
                    </Form>
                </div>

                <!-- 认证授权 -->
                <div class="form-section">
                    <div class="section-title">认证授权</div>
                    <Form ref="changeForm2" :model="changeForm" :rules="changeFormRules" :label-width="140">
                        <FormItem label="授权范围:" prop="authScope">
                            <Input 
                                v-model="changeForm.authScope" 
                                placeholder="速速云签平台"
                                readonly
                                :disabled="true"
                                style="width: 300px;"
                            />
                        </FormItem>
                        <FormItem label="授权期限:" prop="authPeriod">
                            <Select
                                v-model="changeForm.authPeriod"
                                class="auth-period-select"
                                placeholder="请选择授权期限"
                                @on-change="onAuthPeriodChange"
                                style="width: 300px;"
                            >
                                <Option value="longterm">长期有效</Option>
                                <Option value="nonlongterm">非长期有效</Option>
                            </Select>
                            <FormItem 
                                v-if="changeForm.authPeriod === 'nonlongterm'" 
                                prop="authEndDate" 
                                :label-width="0"
                                style="margin-top: 16px;"
                            >
                                <DatePicker 
                                    :value="changeForm.authEndDate"
                                    type="date" 
                                    placeholder="请选择授权结束日期"
                                    :options="datePickerOptions" 
                                    format="yyyy-MM-dd"
                                    @on-change="handleAuthEndDateChange"
                                    style="width: 300px;"
                                />
                            </FormItem>
                        </FormItem>
                    </Form>
                </div>

                <!-- 协议复选框 -->
                <div class="agreement-section" style="padding-bottom: 24px;">
                    <Checkbox v-model="changeForm.agreed">
                        <span>我已仔细阅读并充分理解</span>
                        <a href="#" @click.prevent="viewPrivacyPolicy">《隐私政策》</a>
                        <span>、</span>
                        <a href="#" @click.prevent="viewCertificateAgreement">《数字证书使用协议》</a>
                        <span>，且同意申请数字证书</span>
                    </Checkbox>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="closeChangeFormModal" size="small" class="cancel-btn">取消</Button>
                <Button 
                    type="primary" 
                    @click="confirmChangeForm" 
                    :disabled="!canGoNext || changeExistCheck.isExist"
                    class="confirm-btn"
                    size="small"
                >
                    确定
                </Button>
            </div>
        </Modal>

        <!-- 协议图片弹窗 -->
        <Modal
            v-model="showAgreementModal"
            :mask-closable="false"
            title="协议内容"
            width="900"
            class-name="agreement-image-modal"
        >
            <div class="image-view-content">
                <div class="image-list" v-if="agreementImageList.length > 0">
                    <div
                        class="image-item"
                        v-for="(img, index) in agreementImageList"
                        :key="index"
                    >
                        <img :src="img" style="width: 800px; height: 1132px;" alt="协议图片" @error="handleImageError" />
                    </div>
                </div>
                <div class="empty-image" v-else>
                    <Icon type="ios-image-outline" size="48" />
                    <p>暂无图片</p>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="closeAgreementModal" size="small" class="cancel-btn">关闭</Button>
            </div>
        </Modal>

        <!-- 申请退出通知弹窗 -->
        <Modal
            v-model="showExitNoticeModal"
            :mask-closable="false"
            title="申请退出通知"
            width="1000"
            class-name="exit-notice-modal"
            :footer-hide="true"
            @on-cancel="closeExitNoticeModal"
        >
            <div class="exit-notice-content">
                <!-- 筛选栏 -->
                <div class="filter-bar">
                    <Select v-model="exitNoticeStatus" placeholder="全部" style="width: 200px" @on-change="handleStatusChange">
                        <Option value="">全部</Option>
                        <Option value="0">待审核</Option>
                        <Option value="1">已同意</Option>
                        <Option value="2">已拒绝</Option>
                    </Select>
                    <Button type="primary" @click="getExitNoticeList" style="margin-left: 12px">搜索</Button>
                </div>

                <!-- 列表表格 -->
                <Table 
                    :columns="exitNoticeColumns" 
                    :data="exitNoticeList" 
                    :loading="exitNoticeLoading"
                    style="margin-top: 16px"
                >
                    <template slot-scope="{ index }" slot="index">
                        {{ (exitNoticePage - 1) * exitNoticePageSize + index + 1 }}
                    </template>
                    <template slot-scope="{ row }" slot="member_name">
                        {{ (row.enterprise_user && row.enterprise_user.real_name) || '--' }}
                    </template> 

                    <template slot-scope="{ row }" slot="status">
                        <span v-if="row.status === 0" style="color: #ff9900">待审核</span>
                        <span v-else-if="row.status === 1" style="color: #19be6b">已同意</span>
                        <span v-else-if="row.status === 2" style="color: #ed4014">已拒绝</span>
                        <span v-else>--</span>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <template v-if="enterpriseInfo.is_member === 0">
                            <!-- 管理员：显示审核按钮和详情 -->
                            <Button 
                                v-if="row.status === 0" 
                                type="success" 
                                size="small" 
                                style="margin-right: 8px"
                                @click="handleAgree(row)"
                            >
                                同意
                            </Button>
                            <Button 
                                v-if="row.status === 0" 
                                type="error" 
                                size="small" 
                                style="margin-right: 8px"
                                @click="handleRefuse(row)"
                            >
                                拒绝
                            </Button>
                            <Button 
                                type="primary" 
                                size="small"
                                @click="viewDetail(row)"
                            >
                                详情
                            </Button>
                        </template>
                        <template v-else>
                            <!-- 普通用户：只显示详情 -->
                            <Button 
                                type="primary" 
                                size="small"
                                @click="viewDetail(row)"
                            >
                                详情
                            </Button>
                        </template>
                    </template>
                </Table>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="exitNoticeTotal > 0" style="margin-top: 16px; text-align: right">
                    <Page
                        :total="exitNoticeTotal"
                        :current="exitNoticePage"
                        :page-size="exitNoticePageSize"
                        @on-change="changeExitNoticePage"
                        show-elevator
                        show-total
                    />
                </div>
            </div>
        </Modal>

        <!-- 拒绝理由弹窗 -->
        <Modal
            v-model="showRefuseModal"
            :mask-closable="false"
            title="拒绝理由"
            width="600"
            @on-cancel="closeRefuseModal"
        >
            <div class="refuse-modal-content">
                <Input
                    v-model="refuseReason"
                    type="textarea"
                    :rows="6"
                    placeholder="请输入拒绝理由"
                    :maxlength="500"
                    show-word-limit
                />
            </div>
            <div slot="footer">
                <Button @click="closeRefuseModal" :disabled="refuseSubmitting">取消</Button>
                <Button 
                    type="primary" 
                    @click="confirmRefuse" 
                    :loading="refuseSubmitting"
                    :disabled="!refuseReason || refuseReason.trim() === ''"
                >
                    确定
                </Button>
            </div>
        </Modal>

        <!-- 营业执照示例弹窗（可选：有资源时展示） -->
        <Modal
            v-model="showLicenseExampleModal"
            :mask-closable="true"
            title="营业执照示例"
            width="720"
            class-name="license-example-modal"
        >
            <div style="text-align:center;">
                <img v-if="licenseExampleUrl" :src="licenseExampleUrl" alt="营业执照示例" style="max-width: 100%; max-height: 70vh;" />
                <div v-else style="padding: 24px 0; color: #999;">暂无示例图片</div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="showLicenseExampleModal = false" size="small" class="cancel-btn">关闭</Button>
            </div>
        </Modal>

        <!-- 详情弹窗 -->
        <Modal
            v-model="showDetailModal"
            :mask-closable="false"
            title="详情"
            :footer-hide="true"
            width="600"
            class-name="detail-info-modal"
            @on-cancel="closeDetailModal"
        >
            <div class="detail-modal-content" v-if="currentDetail">
                <div class="detail-card">
                    <div class="detail-item">
                        <div class="detail-label">成员名称：</div>
                        <div class="detail-value">{{ (currentDetail.enterprise_user && currentDetail.enterprise_user.real_name) || '--' }}</div>
                    </div>
                    <div class="detail-item" v-if="currentDetail.enterprise_user && currentDetail.enterprise_user.phone">
                        <div class="detail-label">手机号：</div>
                        <div class="detail-value">{{ currentDetail.enterprise_user.phone || '--' }}</div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-label">理由：</div>
                        <div class="detail-value">{{ currentDetail.reason || '--' }}</div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-label">状态：</div>
                        <div class="detail-value">
                            <span class="status-tag" :class="getStatusClass(currentDetail.status)">
                                {{ getStatusText(currentDetail.status) }}
                            </span>
                        </div>
                    </div>
                    <div class="detail-item" v-if="currentDetail.status === 2 && currentDetail.refuse">
                        <div class="detail-label">拒绝理由：</div>
                        <div class="detail-value ">{{ currentDetail.refuse || '--' }}</div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-label">时间：</div>
                        <div class="detail-value">{{ currentDetail.created_at || '--' }}</div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="detail-modal-footer">
                <Button @click="closeDetailModal" type="primary" class="close-btn">关闭</Button>
            </div>
        </Modal>
    </div>

</template>



<script>
import { get_enterprise_info, get_enterprise_list, getSealStatistics, getAuthrecordList, delAuthRecord, applyQuitEnterprise, delEnterpriseAuth, getAgreement, getQuitRecord, examineApplyRecord, editEnterpriseAuth, getEnterpriseChangeRecord, checkEnterprise, getAuthmiddleEnterpriseList } from '@/api/interFace'
import { getUserList } from '@/api/interFace'
import { sealList } from '@/api/interFace'
import { get_menulist } from '@/api/center.js'
import NotCertified from './NotCertified.vue'
import * as echarts from 'echarts'
import config from '@/config/index'
import { getCookies } from '@/utils/helper'

export default {
    name: 'BasicInfoContent',
    components: {
        NotCertified: NotCertified
    },
    data() {
        return {
            enterpriseInfo: {},
            enterpriseAuthId: '',
            enterpriseList: [],
            enterpriseSwitchLoading: false,
            showNewEnterpriseCert: false,
            memberCount: 0,
            sealCount: 0,
            totalUsage: 0,
            showSettingMenu: false,
            selectedTime: 'recent',
            timeOptions: [
                { label: '最近', value: 'recent' },
                { label: '30天', value: '30days' },
                { label: '90天', value: '90days' },
                { label: '半年', value: 'halfYear' }
            ],
            dateRange: {
                start: '',
                end: ''
            }, 
            dateRangeValue: [],
            chartInstance: null,
            chartDates: [],
            chartValues: [],
            showCancelModal: false,
            agreedToCancel: false,
            cancelSubmitting: false,
            showExitModal: false,
            exitReason: '',
            exitSubmitting: false,
            showRecordModal: false,
            changeRecords: [],
            changeRecordsLoading: false,
            changeRecordPage: 1,
            changeRecordPageSize: 20,
            changeRecordTotal: 0,
            showAuthModal: false,
            showWaitCertModal: false,
            waitCertLoading: false,
            waitCertList: [],
            waitCertPage: 1,
            waitCertPageSize: 20,
            waitCertTotal: 0,
            authLoading: false,
            authPage: 1,
            authPageSize: 10,
            authTotal: 0,
            authRecords: [],
            authColumns: [
                {
                    title: '授权人',
                    key: 'operator_name',
                    align: 'center'
                },
                {
                    title: '手机号',
                    key: 'phone',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', this.formatPhone(params.row.phone))
                    }
                },
                {
                    title: '证件号',
                    key: 'operator_id_card',
                    align: 'center',
                    render: (h, params) => {
                        const id = params.row.operator_id_card || ''
                        if (id.length > 6) {
                            return h('span', id.substring(0, 3) + '******' + id.substring(id.length - 2))
                        }
                        return h('span', id || '--')
                    }
                },
                {
                    title: '授权期限',
                    key: 'auth_deadline',
                    align: 'center',
                    render: (h, params) => {
                        if (params.row.is_auth_limit === 0) return h('span', '长期有效')
                        return h('span', params.row.auth_deadline || '--')
                    }
                },
                {
                    title: '状态',
                    key: 'status',
                    align: 'center',
                    render: (h, params) => {
                        const status = params.row.status
                        const statusMap = {
                            0: '待认证',
                            1: '已认证',
                            2: '已取消'
                        }
                        return h('span', statusMap[status] || '--')
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 120
                }
            ],
            waitCertColumns: [
                {
                    title: '#',
                    key: 'index',
                    align: 'center',
                    width: 80,
                    render: (h, params) => {
                        // iView Table 支持 params.index
                        return h('span', (params.index || 0) + 1)
                    }
                },
                {
                    title: '企业名称',
                    key: 'prise_name',
                    align: 'center'
                },
                {
                    title: '状态',
                    key: 'status',
                    align: 'center',
                    render: (h, params) => {
                        const status = params.row && params.row.status
                        const statusMap = {
                            0: '待审核',
                            1: '已认证',
                            2: '已拒绝'
                        }
                        // const text = statusMap[status] || params.row.status_text || '--'
                        
                        const text = '待认证'
                        return h('span', text)
                    }
                },
                {
                    title: '时间',
                    key: 'created_at',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 120
                }
            ],
            showChangeTipModal: false,
            showChangeFormModal: false,
            showAgreementModal: false,
            agreementImageList: [],
            showExitNoticeModal: false,
            exitNoticeList: [],
            exitNoticeLoading: false,
            exitNoticePage: 1,
            exitNoticePageSize: 10,
            exitNoticeTotal: 0,
            exitNoticeStatus: '', // 状态筛选：空=全部，1=待审核，2=已拒绝，3=已同意
            showRefuseModal: false,
            refuseReason: '',
            refuseSubmitting: false,
            currentExamineRecord: null,
            showDetailModal: false,
            currentDetail: null,
            // 营业执照开关：默认不展示（需要时改为 true）
            showLicense: true,
            // 上传配置（复用全局 common/uploads）
            imageAction: config.apiUrl + '/adminapi/common/uploads',
            // 营业执照 OCR 上传接口
            licenseOcrAction: config.apiUrl + '/adminapi/company/upload_identify_license',
            // 营业执照示例图（src/assets/imgs/licenseExample.png）
            licenseExampleUrl: require('@/assets/imgs/licenseExample.png'),
            showLicenseExampleModal: false,
            headers: { 'Authori-zation': getCookies('token') },
            changeForm: {
                orgType: 'enterprise',      // 组织类型：enterprise-企业, individual-个体工商户
                authMethod: 'legal',        // 认证方式：legal-法定代表人
                license: '',                // 营业执照（前端预览 URL：blob/base64）
                license_server_path: '',    // 营业执照（后端返回的 file_path/src，用于提交）
                orgName: '',                // 组织机构名称
                licenseCode: '',            // 统一社会信用代码（只读）
                id_card:'',
                legalPerson: '',            // 法定代表人
                authScope: '速速云签平台',   // 授权范围（只读）
                authPeriod: 'longterm',     // 授权期限：longterm-长期有效, nonlongterm-非长期有效
                authEndDate: '',            // 授权结束日期（非长期有效时必填）
                agreed: false               // 是否同意协议
            },
            // OCR 回填后锁定组织名称（置灰不可编辑）
            changeOrgNameLocked: false,
            // OCR 上传识别中动效（变更弹窗）
            changeLicenseOcrLoading: false,
            // 本地预览 objectURL（用于释放）
            changeLicenseObjectUrl: '',
            // 企业信息变更：组织机构名称重复检查
            changeExistCheck: {
                isExist: false,
                msg: ''
            },
            changeExistCheckKey: '',
            changeExistCheckLoading: false,
            // 日期选择器选项
            datePickerOptions: {
                disabledDate(date) {
                    // 不能选择今天之前的日期
                    return date && date.valueOf() < Date.now() - 86400000
                }
            },
            changeFormRules: {
                license: [
                    {
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (this.showLicense && !this.changeForm.license) {
                                callback(new Error('请上传营业执照！！！'))
                            } else {
                                callback()
                            }
                        }
                    }
                ],
                orgName: [
                    { required: true, message: '请输入组织机构名称', trigger: 'blur' }
                ],
                licenseCode: [
                    { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法定代表人', trigger: 'blur' }
                ],
                authScope: [
                    { required: true, message: '授权范围不能为空', trigger: 'blur' }
                ],
                authPeriod: [
                    { required: true, message: '请选择授权期限', trigger: 'change' }
                ],
                authEndDate: [
                    { 
                        required: true, 
                        message: '请选择授权结束日期', 
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (this.changeForm.authPeriod === 'nonlongterm' && !value) {
                                callback(new Error('请选择授权结束日期'))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            },
            exitNoticeColumns: [
                {
                    title: '#',
                    slot: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '成员名称',
                    slot: 'member_name',
                    align: 'center'
                },
                {
                    title: '理由',
                    slot: 'reason',
                    align: 'center',
                    ellipsis: true
                },
                {
                    title: '状态',
                    slot: 'status',
                    align: 'center'
                },
                {
                    title: '时间',
                    key: 'created_at',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 230
                }
            ]
        }
    },
    computed: {
        canGoNext() {
            const basicValid = this.changeForm.orgName && 
                               this.changeForm.licenseCode && 
                               this.changeForm.legalPerson && 
                               this.changeForm.authPeriod && 
                               this.changeForm.agreed&&
                               this.changeForm.id_card
            
            // 如果选择非长期有效，需要填写授权结束日期
            if (this.changeForm.authPeriod === 'nonlongterm') {
                return basicValid && this.changeForm.authEndDate
            }
            
            return basicValid
        }
    },
    created() {
        this.getEnterpriseList()
        this.getEnterpriseInfo()
        // this.getMemberCount()
        // this.getSealCount()
        this.initDateRange()
    },
    mounted() {
        this.initChart()
        // 点击外部关闭设置菜单
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
        if (this.chartInstance) {
            this.chartInstance.dispose()
        }
    },
    methods: {
        // 拉取可切换的企业列表
        getEnterpriseList() {
            get_enterprise_list().then(res => {
                const list = (res && res.code === 200 && Array.isArray(res.data)) ? res.data : []
                this.enterpriseList = list
            }).catch(err => {
                this.$Message.error((err && err.msg) || '获取企业列表失败')
                this.enterpriseList = []
            })
        },
        // 企业切换：刷新菜单权限（application/get_menulist）
        async handleEnterpriseChange(nextEnterpriseAuthId) {
            if (this.enterpriseSwitchLoading) return
            if (!nextEnterpriseAuthId && nextEnterpriseAuthId !== 0) return

            this.enterpriseSwitchLoading = true
            this.showSettingMenu = false
            try {
                // 确保后续 get_enterprise_info 使用切换后的企业ID
                this.enterpriseAuthId = nextEnterpriseAuthId
                localStorage.setItem('enterprise_auth_id', nextEnterpriseAuthId) 
                await this.refreshMenuPermissions(nextEnterpriseAuthId)
                // 切换后重新拉取企业基础信息/统计
                this.getEnterpriseInfo(nextEnterpriseAuthId || '')
                // 通知主布局刷新企业认证状态（影响企业菜单结构）
                this.$root.$emit('enterprise-switched', nextEnterpriseAuthId)
            } catch (err) {
                this.$Message.error((err && err.msg) || '切换企业失败')
            } finally {
                this.enterpriseSwitchLoading = false
            }
        },
        // 用新 enterprise_auth_id 拉取菜单权限并写入全局 store
        async refreshMenuPermissions(nextEnterpriseAuthId) {
            const res = await get_menulist({ enterprise_auth_id: nextEnterpriseAuthId })
            const menuAll = (res && res.data && res.data.menuAll) ? res.data.menuAll : []
            const uniqueAuth = (res && res.data && res.data.unique_auth) ? res.data.unique_auth : []

            this.$store.commit('setAuth', uniqueAuth)
            this.$store.commit('setMenus', menuAll)

            // 同步设置中心菜单（settingIndex）
            const settingArr = []
            ;(menuAll || []).forEach(item => {
                if (item && item.permissions_rote === 'settingIndex') {
                    settingArr.push(...(item.children || []))
                }
            })
            this.$store.commit('setSetting', settingArr)
        },
        // 打开“认证新企业”（可选传入 enterprise_auth_id，详情从“认证中企业列表”进入）
        openNewEnterpriseCert(enterpriseAuthId = '') {
            this.showNewEnterpriseCert = true
            this.$nextTick(() => {
                setTimeout(() => {
                    const inst = this.$refs.notCertifiedRef
                    if (inst) {
                        inst.enterpriseAuthId = enterpriseAuthId || ''
                        if (typeof inst.goToCertify === 'function') {
                            inst.goToCertify()
                        }
                    }
                }, 0)
            })
        },
        closeWaitCertModal() {
            this.showWaitCertModal = false
        },
        async openWaitCertList() {
            this.waitCertPage = 1
            this.showWaitCertModal = true
            await this.getWaitCertList()
        },
        async getWaitCertList() {
            this.waitCertLoading = true
            try {
                const res = await getAuthmiddleEnterpriseList({
                    page: this.waitCertPage,
                    limit: this.waitCertPageSize
                })
                if (res && res.code === 200) {
                    const raw = res.data 
                    if (Array.isArray(raw)) {
                        this.waitCertList = raw
                        this.waitCertTotal = 0
                    } else if (raw && Array.isArray(raw.data)) {
                        this.waitCertList = raw.data
                        this.waitCertTotal = raw.total || 0
                    } else if (raw && Array.isArray(raw.list)) {
                        this.waitCertList = raw.list
                        this.waitCertTotal = raw.total || 0
                    } else {
                        this.waitCertList = []
                        this.waitCertTotal = 0
                    }
                } else {
                    this.waitCertList = []
                    this.waitCertTotal = 0
                }
            } catch (err) {
                this.$Message.error((err && err.msg) || '获取认证中企业列表失败')
                this.waitCertList = []
                this.waitCertTotal = 0
            } finally {
                this.waitCertLoading = false
            }
        },
        handleWaitCertPageChange(page) {
            this.waitCertPage = page
            this.getWaitCertList()
        },
        handleWaitCertDetail(row) {
            const id = row && row.id ? row.id : ''
            this.showWaitCertModal = false 
            this.$refs.notCertifiedRef.changeNewEnterpriseCertType('info')
            this.openNewEnterpriseCert(id)
        },
        closeNewEnterpriseCert() {
            this.showNewEnterpriseCert = false
            this.getEnterpriseList()
        },
        clearChangeExistCheck() {
            this.changeExistCheck = { isExist: false, msg: '' }
            this.changeExistCheckKey = ''
        },
        async handleChangeOrgNameBlur() {
            const name = (this.changeForm.orgName || '').trim()
            if (!name) {
                this.clearChangeExistCheck()
                return
            }
            if (!this.enterpriseAuthId) {
                // enterprise_auth_id 未就绪时先不校验，避免误报
                this.clearChangeExistCheck()
                return
            }
            const key = `${this.enterpriseAuthId}::${name}`
            if (this.changeExistCheckLoading) return
            if (this.changeExistCheckKey === key) return

            this.changeExistCheckLoading = true
            try {
                // type=1 企业名称；变更场景需要带 enterprise_auth_id 排除本企业
                const res = await checkEnterprise({ type: 1, name, enterprise_auth_id: this.enterpriseAuthId })
                const payload = (res && res.data) || {}
                this.changeExistCheck = {
                    isExist: !!payload.is_exist,
                    msg: payload.msg || ''
                }
                this.changeExistCheckKey = key
            } catch (err) {
                this.clearChangeExistCheck()
                this.$Message.error(err.msg || '企业检查失败')
            } finally {
                this.changeExistCheckLoading = false
            }
        },
        getEnterpriseInfo(enterpriseAuthId) {
            get_enterprise_info({ enterprise_auth_id: enterpriseAuthId || localStorage.getItem('enterprise_auth_id') || '' }).then(res => {
                if (res && res.code === 200 && res.data && res.data.enterprise_info) {
                    const info = res.data.enterprise_info
                    this.enterpriseAuthId = info.id
                    this.enterpriseInfo = {
                        company_name: info.prise_name,
                        license_register: info.credit_code,
                        legal_person: info.real_name,
                        is_member: info.is_member
                    }
                    this.memberCount = res.data.member_num
                    this.sealCount = res.data.seal_num
                    // 企业信息到位后拉一次图表数据
                    this.getChartData()
                }
            }).catch(err => {
                this.$Message.error(err.msg || '获取企业信息失败')
            })
        },
        getMemberCount() {
            getUserList({ page: 1, limit: 1 }).then(res => {
                if (res.data && res.data.total) {
                    this.memberCount = res.data.total
                } else {
                    // 模拟数据
                    this.memberCount = 20
                }
            }).catch(() => {
                // 模拟数据
                this.memberCount = 20
            })
        },
        getSealCount() {
            sealList({ page: 1, limit: 1, enterprise_auth_id: localStorage.getItem('enterprise_auth_id') || '' }).then(res => {
                if (res.data && res.data.total) {
                    this.sealCount = res.data.total
                } else {
                    // 模拟数据
                    this.sealCount = 20
                }
            }).catch(() => {
                // 模拟数据
                this.sealCount = 20
            })
        },
        initDateRange() {
            // 初始化日期范围，默认最近
            this.calculateDateRange('recent')
        },
        calculateDateRange(type) {
            const today = new Date()
            const endDate = new Date(today)
            let startDate = new Date(today)

            switch(type) {
                case 'recent':
                    // 最近：今天往前一周到今天
                    startDate.setDate(today.getDate() - 7)
                    break
                case '30days':
                    // 30天：今天往前30天到今天
                    startDate.setDate(today.getDate() - 30)
                    break
                case '90days':
                    // 90天：今天往前90天到今天
                    startDate.setDate(today.getDate() - 90)
                    break
                case 'halfYear':
                    // 半年：今天往前180天到今天
                    startDate.setDate(today.getDate() - 180)
                    break
            }

            // 格式化日期
            const formatDate = (date) => {
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                return `${year}-${month}-${day}`
            }

            this.dateRange = {
                start: formatDate(startDate),
                end: formatDate(endDate)
            }

            // 更新日期选择器的值
            this.dateRangeValue = [formatDate(startDate), formatDate(endDate)]
        },
        selectTime(value) {
            this.selectedTime = value
            this.calculateDateRange(value)
            this.getChartData()
        },
        handleDateChange(dates) {
            if (dates && dates.length === 2) {
                this.dateRange = {
                    start: dates[0],
                    end: dates[1]
                }
                // 手动选择日期时，检查是否匹配某个预设选项
                const daysDiff = this.getDaysDiff(dates[0], dates[1])
                let matchedOption = ''
                
                if (daysDiff === 7) {
                    matchedOption = 'recent'
                } else if (daysDiff === 30) {
                    matchedOption = '30days'
                } else if (daysDiff === 90) {
                    matchedOption = '90days'
                } else if (daysDiff >= 175 && daysDiff <= 185) {
                    matchedOption = 'halfYear'
                }
                
                this.selectedTime = matchedOption
                this.getChartData()
            }
        },
        refresh() {
            this.$emit('refresh')
        },
        getDaysDiff(start, end) {
            const startDate = new Date(start)
            const endDate = new Date(end)
            const diffTime = Math.abs(endDate - startDate)
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            return diffDays
        },
        generateDateList(start, end) {
            if (!start || !end) return []
            
            const startDate = new Date(start)
            const endDate = new Date(end)
            const dates = []
            const currentDate = new Date(startDate)

            while (currentDate <= endDate) {
                const year = currentDate.getFullYear()
                const month = String(currentDate.getMonth() + 1).padStart(2, '0')
                const day = String(currentDate.getDate()).padStart(2, '0')
                dates.push(`${year}-${month}-${day}`)
                currentDate.setDate(currentDate.getDate() + 1)
            }

            return dates
        },
        generateMockData(length) {
            // 生成模拟数据
            const data = []
            for (let i = 0; i < length; i++) {
                data.push(Math.floor(Math.random() * 5) + 1)
            }
            return data
        },
        getChartData() {
            if (!this.enterpriseAuthId) {
                this.chartDates = this.generateDateList(this.dateRange.start, this.dateRange.end)
                this.chartValues = this.chartDates.map(() => 0)
                this.totalUsage = 0
                this.updateChart()
                return
            }
            const { start, end } = this.dateRange
            const dates = this.generateDateList(start, end)
            getSealStatistics({
                auth_id: this.enterpriseAuthId,
                start_date: start,
                end_date: end
            }).then(res => {
                const rows = (res && res.code === 200 && res.data) ? res.data : []
                const map = new Map()
                rows.forEach(r => {
                    // use_time 形如 2026-01-15
                    map.set(r.use_time, Number(r.num || 0))
                })
                const values = dates.map(d => map.get(d) || 0)
                this.chartDates = dates
                this.chartValues = values
                this.totalUsage = values.reduce((sum, v) => sum + v, 0)
                this.updateChart()
            }).catch(err => {
                this.$Message.error(err.msg || '获取用印统计失败')
                this.chartDates = dates
                this.chartValues = dates.map(() => 0)
                this.totalUsage = 0
                this.updateChart()
            })
        },
        initChart() {
            this.$nextTick(() => {
                const chartDom = document.getElementById('sealUsageChart')
                if (!chartDom) return
                
                this.chartInstance = echarts.init(chartDom)
                this.updateChart()
            })
        },
        updateChart() {
            if (!this.chartInstance) return

            const dates = this.chartDates.length ? this.chartDates : this.generateDateList(this.dateRange.start, this.dateRange.end)
            const values = this.chartValues.length ? this.chartValues : dates.map(() => 0)

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: dates,
                    axisLine: {
                        lineStyle: {
                            color: '#e8eaec'
                        }
                    },
                    axisLabel: {
                        color: '#808695'
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    max: Math.max(5, ...values),
                    axisLine: {
                        lineStyle: {
                            color: '#e8eaec'
                        }
                    },
                    axisLabel: {
                        color: '#808695'
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#f0f0f0',
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '用印次数',
                        type: 'line',
                        smooth: true,
                        data: values,
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'rgba(26, 154, 239, 0.3)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(26, 154, 239, 0.05)'
                                    }
                                ]
                            }
                        },
                        itemStyle: {
                            color: '#1a9aef'
                        },
                        lineStyle: {
                            color: '#1a9aef',
                            width: 2
                        },
                        symbol: 'circle',
                        symbolSize: 6
                    }
                ]
            }

            this.chartInstance.setOption(option)

            // 响应式调整
            window.addEventListener('resize', () => {
                if (this.chartInstance) {
                    this.chartInstance.resize()
                }
            })
        },
        handleMenuClick(type) {
            this.showSettingMenu = false
            switch(type) {
                case 'auth':
                    this.showAuthModal = true
                    this.getAuthRecords()
                    break
                case 'change':
                    this.showChangeTipModal = true
                    break
                case 'waitCert':
                    this.openWaitCertList()
                    break
                case 'record':
                    this.showRecordModal = true
                    this.changeRecordPage = 1
                    this.getChangeRecords()
                    break
                case 'newEnterpriseCert': 
                    this.$refs.notCertifiedRef.changeNewEnterpriseCertType('add')
                    this.openNewEnterpriseCert()
                    break
                case 'exit':
                    this.showExitModal = true
                    this.exitReason = ''
                    break
                case 'cancel':
                    this.showCancelModal = true
                    this.agreedToCancel = false
                    break
                case 'exitNotice':
                    this.showExitNoticeModal = true
                    this.exitNoticePage = 1
                    this.exitNoticeStatus = ''
                    this.getExitNoticeList()
                    break
            }
        },
        // NotCertified 认证完成后回调
        handleNotCertifiedRefresh() {
            this.showNewEnterpriseCert = false
            this.getEnterpriseInfo()
            this.getEnterpriseList()

            // 尝试刷新当前企业菜单权限（认证成功后可能有变化）
            setTimeout(() => {
                if (this.enterpriseAuthId) {
                    this.refreshMenuPermissions(this.enterpriseAuthId)
                }
            }, 600)
        },
        handleClickOutside(event) {
            if (this.$refs.settingIcon && !this.$refs.settingIcon.contains(event.target)) {
                this.showSettingMenu = false
            }
        },
        closeCancelModal() {
            this.showCancelModal = false
            this.agreedToCancel = false
            this.cancelSubmitting = false
        },
        async confirmCancel() {
            if (!this.agreedToCancel) {
                this.$Message.warning('请先阅读并同意《注销协议》')
                return
            }
            if (!this.enterpriseAuthId) {
                this.$Message.error('缺少企业认证ID，无法提交注销申请')
                return
            }
            if (this.cancelSubmitting) return

            this.cancelSubmitting = true
            try {
                const res = await delEnterpriseAuth({
                    enterprise_auth_id: this.enterpriseAuthId
                })
                this.$Message.success(res.msg || '注销申请已提交')
                this.closeCancelModal()
                // 注销成功后可能需要跳转或刷新页面
                // 根据业务需求决定是否需要刷新企业信息
                // this.getEnterpriseInfo()
                setTimeout(() => { 
                // window.location.reload();  //清除缓存刷新页面
                    location.reload();
                }, 500) 
            } catch (err) {
                this.$Message.error(err.msg || '提交注销申请失败')
            } finally {
                this.cancelSubmitting = false
            }
        },
        viewAgreement() {
            this.openAgreementByType(4)
        },
        closeExitModal() {
            this.showExitModal = false
            this.exitReason = ''
            this.exitSubmitting = false
        },
        async confirmExit() {
            const reason = (this.exitReason || '').trim()
            if (!reason) {
                this.$Message.warning('请输入退出理由')
                return
            }
            if (!this.enterpriseAuthId) {
                this.$Message.error('缺少企业认证ID，无法提交申请')
                return
            }
            if (this.exitSubmitting) return

            this.exitSubmitting = true
            try {
                const res = await applyQuitEnterprise({
                    enterprise_auth_id: String(this.enterpriseAuthId),
                    reason: String(reason)
                })
                this.$Message.success(res.msg || '申请已提交')
                this.closeExitModal()
                // 提交成功后刷新一下企业信息（可能会影响页面状态/按钮）
                this.getEnterpriseInfo()
            } catch (err) {
                this.$Message.error(err.msg || '提交申请失败')
            } finally {
                this.exitSubmitting = false
            }
        },
        closeRecordModal() {
            this.showRecordModal = false
            this.changeRecordPage = 1
            this.changeRecords = []
            this.changeRecordTotal = 0
        },
        async getChangeRecords() {
            if (!this.enterpriseAuthId) {
                this.$Message.error('缺少企业认证ID，无法获取变更记录')
                return
            }
            this.changeRecordsLoading = true
            try {
                const params = {
                    page: String(this.changeRecordPage),
                    limit: String(this.changeRecordPageSize)
                }
                const res = await getEnterpriseChangeRecord({
                    ...params,
                    enterprise_auth_id: this.enterpriseAuthId || ''
                })
                if (res && res.code === 200 && res.data) {
                    this.changeRecords = res.data.data || []
                    this.changeRecordTotal = res.data.total || 0
                } else {
                    this.changeRecords = []
                    this.changeRecordTotal = 0
                }
            } catch (err) {
                this.$Message.error(err.msg || '获取变更记录失败')
                this.changeRecords = []
                this.changeRecordTotal = 0
            } finally {
                this.changeRecordsLoading = false
            }
        },
        changeRecordPageHandler(page) {
            this.changeRecordPage = page
            this.getChangeRecords()
        },
        formatPhone(phone) {
            if (!phone) return ''
            if (phone.length === 11) {
                return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
            }
            return phone
        },
        closeAuthModal() {
            this.showAuthModal = false
        },
        getAuthRecords() {
            this.authLoading = true
            if (!this.enterpriseAuthId) {
                this.authRecords = []
                this.authTotal = 0
                this.authLoading = false
                return
            }
            getAuthrecordList({
                enterprise_auth_id: this.enterpriseAuthId,
                page: this.authPage,
                limit: 10
            }).then(res => {
                if (res && res.code === 200 && res.data) {
                    this.authRecords = res.data.data || []
                    this.authTotal = res.data.total || 0
                    this.authPageSize = 10
                } else {
                    this.authRecords = []
                    this.authTotal = 0
                }
            }).catch(err => {
                this.$Message.error(err.msg || '获取认证授权记录失败')
                this.authRecords = []
                this.authTotal = 0
            }).finally(() => {
                this.authLoading = false
            })
        },
        changeAuthPage(page) {
            this.authPage = page
            this.getAuthRecords()
        },
        cancelAuth(row) {
            this.$Modal.confirm({
                title: '确认取消授权',
                content: `确定要取消对 ${row.operator_name || '--'} 的授权吗？`,
                onOk: () => {
                    // 接口参数名为 enterprise_auth_id，但含义为“授权记录列表ID”
                    delAuthRecord({ enterprise_auth_id: row.id }).then(res => {
                        this.$Message.success(res.msg || '取消授权成功')
                        // 如果当前页删到空，回退一页
                        if (this.authRecords.length === 1 && this.authPage > 1) {
                            this.authPage -= 1
                        }
                        this.getAuthRecords()
                    }).catch(err => {
                        this.$Message.error(err.msg || '取消授权失败')
                    })
                }
            })
        },
        closeChangeTipModal() {
            this.showChangeTipModal = false
        },
        async confirmChangeTip(enterpriseAuthId) {
            this.showChangeTipModal = false
            // 获取企业信息，用于回显表单
            try {
                const res = await get_enterprise_info({ enterprise_auth_id:  localStorage.getItem('enterprise_auth_id') || '' })
                const data = (res && res.data) || {}
                const enterpriseInfo = data.enterprise_info || {}
                
                // 初始化表单数据
                this.changeForm = {
                    orgType: enterpriseInfo.type === 2 ? 'individual' : 'enterprise',
                    authMethod: 'legal',
                    orgName: enterpriseInfo.prise_name || this.enterpriseInfo.company_name || '',
                    licenseCode: enterpriseInfo.credit_code || this.enterpriseInfo.license_register || '',
                    legalPerson: enterpriseInfo.real_name || this.enterpriseInfo.legal_person || '',
                    authScope: '速速云签平台',
                    id_card:enterpriseInfo.id_card || this.enterpriseInfo.id_card || '',
                    authPeriod: enterpriseInfo.is_auth_limit === 1 ? 'nonlongterm' : 'longterm',
                    authEndDate: enterpriseInfo.auth_deadline || '',
                    agreed: false
                }
                this.clearChangeExistCheck()
                this.showChangeFormModal = true
            } catch (err) {
                // 如果获取失败，使用基本信息初始化
                this.changeForm = {
                    orgType: 'enterprise',
                    authMethod: 'legal',
                    orgName: this.enterpriseInfo.company_name || '',
                    licenseCode: this.enterpriseInfo.license_register || '',
                    legalPerson: this.enterpriseInfo.legal_person || '',
                    authScope: '速速云签平台',
                    id_card:'',
                    authPeriod: 'longterm',
                    authEndDate: '',
                    agreed: false
                }
                this.clearChangeExistCheck()
                this.showChangeFormModal = true
            }
        },
        onAuthPeriodChange(val) {
            if (val === 'longterm') {
                this.changeForm.authEndDate = ''
            }
        },
        // 授权结束日期选择（统一为 YYYY-MM-DD 字符串）
        handleAuthEndDateChange(value) {
            // iView 的 DatePicker on-change 直接返回格式化后的字符串
            this.changeForm.authEndDate = value || ''
        },
        closeChangeFormModal() {
            this.showChangeFormModal = false
            this.$refs.changeForm && this.$refs.changeForm.resetFields()
            this.clearChangeExistCheck()
        },
        confirmChangeForm() {
            this.$refs.changeForm.validate((valid) => {
                if (valid) {
                    this.$refs.changeForm2.validate((valid2) => {
                        if (valid2) {
                            if (!this.changeForm.agreed) {
                                this.$Message.warning('请先阅读并同意相关协议')
                                return
                            }
                            if (this.changeExistCheck.isExist) {
                                this.$Message.warning(this.changeExistCheck.msg || '平台中存在已认证的同名组织机构')
                                return
                            }
                            this.submitEnterpriseChange()
                        }
                    })
                }
            })
        },
        async submitEnterpriseChange() {
            if (!this.enterpriseAuthId) {
                this.$Message.error('缺少企业认证ID，无法提交变更')
                return
            }
            try {
                const payload = {
                    // 企业名称
                    prise_name: this.changeForm.orgName,
                    // 法人姓名
                    real_name: this.changeForm.legalPerson,
                    // 认证企业ID
                    enterprise_auth_id: this.enterpriseAuthId,
                    // 授权日期（当is_auth_limit==1时才需要传日期）
                    auth_deadline: this.changeForm.authPeriod === 'longterm' ? '' : this.changeForm.authEndDate,
                    // 是否有限 1是0无限
                    is_auth_limit: this.changeForm.authPeriod === 'longterm' ? 0 : 1,
                    // 组织类型: 1企业2个体工商户
                    type: this.changeForm.orgType === 'enterprise' ? 1 : 2,
                    // 认证方式:1法人代表
                    auth_type: 1,
                    id_card: this.changeForm.id_card,
                    // 营业执照
                    business_license: this.changeForm.license_server_path || ''
                }
                const res = await editEnterpriseAuth(payload)
                this.$Message.success(res.msg || '企业信息变更申请已提交')
                this.closeChangeFormModal()
                // 刷新企业信息
                this.getEnterpriseInfo()
            } catch (err) {
                this.$Message.error(err.msg || '提交变更申请失败')
            }
        },
        onChangeLicenseUploadSuccess(e) {
            this.changeLicenseOcrLoading = false
            const payload = (e && e.data) || {}
            const filePath = payload.file_path || payload.src || ''
            this.changeForm.license_server_path = filePath || ''

            // 自动回填 OCR 识别结果
            if (payload.company_name) {
                this.changeForm.orgName = payload.company_name
                this.changeOrgNameLocked = true
            }

            if(payload.credit_code != this.changeForm.licenseCode) {
                this.$Message.error('上传的营业执照与已认证的营业执照信用代码不一致！')
            }
            // if (payload.credit_code) {
            //     this.changeForm.licenseCode = payload.credit_code
            // }
            if (payload.legal_person) {
                this.changeForm.legalPerson = payload.legal_person
            }

            this.$Message.success((e && e.msg) || '上传并识别成功')

            // OCR 回填后，自动进行企业名称存在性检测（变更场景会带 enterprise_auth_id 排除本企业）
            if (payload.company_name) {
                this.handleChangeOrgNameBlur().then(() => {
                    if (this.changeExistCheck && this.changeExistCheck.isExist) {
                        this.$Message.warning(this.changeExistCheck.msg || '平台中存在已认证的同名组织机构')
                    }
                })
            }

            this.$nextTick(() => {
                if (this.$refs.changeForm && this.$refs.changeForm.validateField) {
                    this.$refs.changeForm.validateField('license')
                    this.$refs.changeForm.validateField('orgName')
                    this.$refs.changeForm.validateField('licenseCode')
                    this.$refs.changeForm.validateField('legalPerson')
                }
            })
        },
        onLicenseFormatError() {
            this.changeLicenseOcrLoading = false
            this.$Message.warning('仅支持上传 jpg/png 图片')
        },
        beforeChangeLicenseOcrUpload(file) {
            this.changeLicenseOcrLoading = true
            // 本地预览：即使后端不返回全路径也可展示
            try {
                if (this.changeLicenseObjectUrl) URL.revokeObjectURL(this.changeLicenseObjectUrl)
                const objectUrl = URL.createObjectURL(file)
                this.changeLicenseObjectUrl = objectUrl
                this.changeForm.license = objectUrl
            } catch (err) {
                // ignore
            }
            this.changeForm.license_server_path = ''
            return true
        },
        onChangeLicenseOcrError() {
            this.changeLicenseOcrLoading = false
            this.$Message.error('上传失败，请重试')
        },
        openLicenseExample() {
            if (!this.licenseExampleUrl) {
                this.$Message.info('暂无示例图片')
                return
            }
            this.showLicenseExampleModal = true
        },
        previewChangeLicense() {
            if (!this.changeForm.license) return
            window.open(this.changeForm.license)
        },
        removeChangeLicense() {
            this.changeForm.license = ''
            this.changeForm.license_server_path = ''
            // 删除营业执照时清空 OCR 回填数据 & 解除锁定
            this.changeForm.orgName = ''
            // this.changeForm.licenseCode = ''
            this.changeForm.legalPerson = ''
            this.changeOrgNameLocked = false
            this.changeLicenseOcrLoading = false
             
            try {
                if (this.changeLicenseObjectUrl) URL.revokeObjectURL(this.changeLicenseObjectUrl)
            } catch (err) {
                // ignore
            }
            this.changeLicenseObjectUrl = ''
            this.clearChangeExistCheck()
            this.$nextTick(() => {
                if (this.$refs.changeForm && this.$refs.changeForm.validateField) {
                    this.$refs.changeForm.validateField('license')
                    this.$refs.changeForm.validateField('orgName')
                    this.$refs.changeForm.validateField('licenseCode')
                    this.$refs.changeForm.validateField('legalPerson')
                }
            })
        },
        normalizeOcrFileUrl(filePath) {
            const raw = (filePath || '').trim()
            if (!raw) return ''
            if (/^https?:\/\//.test(raw)) return raw
            try {
                const origin = new URL(this.licenseOcrAction).origin
                const normalizedPath = raw.replace(/^\/+/, '')
                return `${origin}/${normalizedPath}`
            } catch (err) {
                return raw
            }
        },
        viewPrivacyPolicy() {
            this.openAgreementByType(2)
        },
        viewCertificateAgreement() {
            this.openAgreementByType(3)
        },
        async openAgreementByType(type) {
            try {
                const res = await getAgreement({ type })
                const list = (res && res.code === 200 && Array.isArray(res.data)) ? res.data : []
                const item = list.find(it => Number(it.type) === Number(type))
                const urls = (item && item.contract_imgs_url) || []
                if (urls.length === 0) {
                    this.$Message.warning('暂未配置协议内容')
                    return
                }
                // 使用单独的协议弹窗展示全部协议图片
                this.agreementImageList = urls
                this.showAgreementModal = true
            } catch (err) {
                this.$Message.error('获取协议内容失败')
            }
        },
        closeAgreementModal() {
            this.showAgreementModal = false
            this.agreementImageList = []
        },
        handleImageError(e) {
            // e.target.src = require('@/assets/imgs/default-image.png')
        },
        // 获取申请退出通知列表
        async getExitNoticeList() {
            if (!this.enterpriseAuthId) {
                this.$Message.error('缺少企业认证ID，无法获取列表')
                return
            }
            this.exitNoticeLoading = true
            try {
                const params = {
                    page: String(this.exitNoticePage),
                    limit: String(this.exitNoticePageSize),
                    enterprise_auth_id: String(this.enterpriseAuthId),
                    status: this.exitNoticeStatus === '' ? '' : this.exitNoticeStatus
                }
                const res = await getQuitRecord(params)
                if (res && res.code === 200 && res.data) {
                    this.exitNoticeList = res.data.data || []
                    this.exitNoticeTotal = res.data.total || 0
                } else {
                    this.exitNoticeList = []
                    this.exitNoticeTotal = 0
                }
            } catch (err) {
                this.$Message.error(err.msg || '获取申请退出通知列表失败')
                this.exitNoticeList = []
                this.exitNoticeTotal = 0
            } finally {
                this.exitNoticeLoading = false
            }
        },
        // 状态筛选改变
        handleStatusChange() {
            this.exitNoticePage = 1
            this.getExitNoticeList()
        },
        // 分页改变
        changeExitNoticePage(page) {
            this.exitNoticePage = page
            this.getExitNoticeList()
        },
        // 关闭申请退出通知弹窗
        closeExitNoticeModal() {
            this.showExitNoticeModal = false
            this.exitNoticeList = []
            this.exitNoticePage = 1
            this.exitNoticeStatus = ''
            this.exitNoticeTotal = 0
        },
        // 同意申请
        async handleAgree(row) {
            const memberName = (row.enterprise_user && row.enterprise_user.real_name) || '该成员'
            this.$Modal.confirm({
                title: '确认同意',
                content: `确定要同意 ${memberName} 的退出申请吗？`,
                onOk: async () => {
                    try {
                        const res = await examineApplyRecord({
                            id: String(row.id),
                            status: '1',
                            refuse: ''
                        })
                        this.$Message.success(res.msg || '操作成功')
                        this.getExitNoticeList()
                    } catch (err) {
                        this.$Message.error(err.msg || '操作失败')
                    }
                }
            })
        },
        // 拒绝申请
        handleRefuse(row) {
            this.currentExamineRecord = row
            this.refuseReason = ''
            this.showRefuseModal = true
        },
        // 确认拒绝
        async confirmRefuse() {
            if (!this.refuseReason || this.refuseReason.trim() === '') {
                this.$Message.warning('请输入拒绝理由')
                return
            }
            if (!this.currentExamineRecord) {
                this.$Message.error('缺少申请记录信息')
                return
            }
            if (this.refuseSubmitting) return

            this.refuseSubmitting = true
            try {
                const res = await examineApplyRecord({
                    id: String(this.currentExamineRecord.id),
                    status: '2',
                    refuse: String(this.refuseReason.trim())
                })
                this.$Message.success(res.msg || '操作成功')
                this.closeRefuseModal()
                this.getExitNoticeList()
            } catch (err) {
                this.$Message.error(err.msg || '操作失败')
            } finally {
                this.refuseSubmitting = false
            }
        },
        // 关闭拒绝理由弹窗
        closeRefuseModal() {
            this.showRefuseModal = false
            this.refuseReason = ''
            this.currentExamineRecord = null
            this.refuseSubmitting = false
        },
        // 查看详情
        viewDetail(row) {
            this.currentDetail = { ...row }
            this.showDetailModal = true
        },
        // 关闭详情弹窗
        closeDetailModal() {
            this.showDetailModal = false
            this.currentDetail = null
        },
        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                0: '待审核',
                1: '已同意',
                2: '已拒绝'
            }
            return statusMap[status] || '--'
        },
        // 获取状态样式类
        getStatusClass(status) {
            const classMap = {
                0: 'status-pending',
                1: 'status-approved',
                2: 'status-rejected'
            }
            return classMap[status] || ''
        }
    }
}
</script>

<style scoped lang="scss">
.page_wrap {
    width: 100%;
    min-height: 100%;
    background: #EDF0F9; 
}

/* 营业执照上传（默认 showLicense=false，不影响现有页面） */
.license-upload-wrap {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}
.license-left {
    display: flex;
    flex-direction: column;
    position: relative;
}
.license-right {
    padding-top: 6px;
    min-width: 220px;
}
.license-example {
    display: inline-block;
    color: #2d8cf0;
    font-size: 12px;
    margin-bottom: 8px;
}
.license-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
}
.license-uploader {
    width: 160px;
    height: 110px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.license-uploader .plus {
    font-size: 32px;
    color: #c0c4cc;
    line-height: 32px;
}
.license-uploader .tips {
    margin-top: 6px;
    font-size: 12px;
    color: #999;
}
.license-preview {
    display: flex;
    align-items: center;
}
.license-img {
    width: 160px;
    height: 110px;
    border-radius: 6px;
    object-fit: cover;
    border: 1px solid #eee;
}
.license-actions {
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}
.license-actions .ivu-btn {
    margin-left: 0 !important;
}

/* 组织名称锁定后置灰 */
::v-deep .locked-input {
    .ivu-input {
        background: #f5f5f5 !important;
        color: #999 !important;
        cursor: not-allowed;
    }
}


/* 企业切换下拉：去掉 iView Select 外边框（样式覆盖） */
::v-deep .enterprise-switch-select {
    .ivu-select-selection {
        border: none !important;
        box-shadow: none !important;
        font-size: 16px;
    }

    .ivu-select-selection:hover {
        border: none !important;
        box-shadow: none !important;
    }

    .ivu-select-selection:focus-within {
        border: none !important;
        box-shadow: none !important;
    }

    // iView Select 内部：选中值/占位符字体放大
    .ivu-select-placeholder,
    .ivu-select-selected-value {
        font-size: 18px;
    }

    // 下拉列表项字体放大
    .ivu-select-dropdown .ivu-select-item {
        font-size: 18px;
    }
}

/* OCR 识别中动效遮罩 */
.license-ocr-loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 160px;
    height: 110px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
}
.license-ocr-loading .txt {
    margin-top: 6px;
    font-size: 12px;
    color: #666;
}
.license-ocr-loading .dots {
    display: flex;
    gap: 6px;
}
.license-ocr-loading .dots span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4877E8;
    opacity: 0.3;
    animation: licenseDots 0.9s infinite ease-in-out;
}
.license-ocr-loading .dots span:nth-child(2) {
    animation-delay: 0.15s;
}
.license-ocr-loading .dots span:nth-child(3) {
    animation-delay: 0.3s;
}
@keyframes licenseDots {
    0%, 100% { opacity: 0.3; transform: translateY(0); }
    50% { opacity: 1; transform: translateY(-4px); }
}
.license-remind {
    margin-top: 8px;
    padding: 0 10px;
    background: #fff7e6;
    border: 1px solid #ffd591;
    border-radius: 6px;
    font-size: 12px;
    color: #ad4e00;
    width: fit-content;
}

.content-layout {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.left-card {
    flex: 1;
}

.enterprise-card {
    background: #fff;
    border-radius: 8px;
    padding: 40px ;
    position: relative;
    min-height: 160px;

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .card-title {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            color: #17233d;
        }

        .setting-icon {
            position: relative;
            cursor: pointer;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                height: 100%;
            }

            .setting-menu {
                position: absolute;
                top: 30px;
                right: 0;
                background: #fff;
                border-radius: 4px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                z-index: 1000;
                min-width: 160px;
                padding: 4px 0;

                .menu-item {
                    padding: 10px 16px;
                    font-size: 14px;
                    color: #17233d;
                    cursor: pointer;
                    transition: background-color 0.2s;

                    &:hover {
                        background-color: #f5f7fa;
                    }
                }
            }
        }
    }

    .card-content {
        .info-row {
            margin-bottom: 15px;
            font-size: 14px;

            &:last-child {
                margin-bottom: 0;
            }

            .info-label {
                color: #515a6e;
                margin-right: 8px;
                
            }

            .info-value {
                color: #17233d;
            }
        }
    }
}

.right-cards {
    display: flex;
    gap: 20px;
    width: 400px;
}

.stat-card {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .stat-label {
        font-size: 16px;
        color: #808695;
        margin-bottom: 12px; 
    }

    .stat-value {
        font-size: 32px;
        font-weight: bold;
        color: #4877E8;
    }
}

.chart-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;

    .chart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .chart-title {
            font-size: 16px;
            font-weight: bold;
            color: #17233d;
        }

        .chart-controls {
            display: flex;
            align-items: center;
            gap: 20px;

            .time-selector {
                display: flex;
                gap: 8px;

                .time-option {
                    padding: 6px 16px;
                    font-size: 14px;
                    color: #515a6e;
                    cursor: pointer;
                    border-radius: 4px;
                    transition: all 0.2s;

                    &:hover {
                        background-color: #f5f7fa;
                    }

                    &.active {
                        background-color: #4877E8;
                        color: #fff;
                    }
                }
            }

            .date-range {
                display: flex;
                align-items: center;

                ::v-deep .ivu-date-picker {
                    .ivu-input-wrapper {
                        .ivu-input {
                            font-size: 14px;
                            color: #515a6e;
                        }
                    }
                }
            }
        }
    }

    .chart-container {
        width: 100%;
        height: 400px;
    }
}

// 响应式布局
@media (max-width: 1200px) {
    .content-layout {
        flex-direction: column;
    }

    .right-cards {
        width: 100%;
    }
}

 

.cancel-modal-content {
    padding: 0 40px 30px;

    .warning-header {
        display: flex;
        align-items: flex-start;
        margin-bottom: 16px;

        .warning-icon {
            font-size: 28px;
            color: #FF9900;
            margin-right: 12px;
            margin-top: 2px;
            flex-shrink: 0;
        }

        .warning-title {
            font-size: 18px;
            font-weight: bold;
            color: #17233d;
            line-height: 1.5;

            .company-name {
                color: #4877E8;
            }
        }
    }

    .warning-subtitle {
        font-size: 14px;
        color: #808695;
        margin-bottom: 24px;
        line-height: 1.6;
        padding-left: 40px;
    }

    .consequences-list {
        margin-bottom: 24px;
        background: #f8f9fa;
        border-radius: 4px;
        padding: 0 16px;

        .consequence-item {
            padding: 20px 0;

            .consequence-title {
                font-size: 15px;
                font-weight: 500;
                color: #17233d;
                margin-bottom: 10px;
            }

            .consequence-desc {
                font-size: 14px;
                color: #808695;
                line-height: 1.8;
            }
        }

        .divider {
            height: 1px;
            background: #e8eaec;
            margin: 0;
        }
    }

    .agreement-checkbox {
        padding: 20px 0 0;
        // border-top: 1px solid #e8eaec;
        margin-top: 20px;

        ::v-deep .ivu-checkbox-wrapper {
            font-size: 14px;
            color: #17233d;
        }

        .agreement-link {
            color: #4877E8;
            text-decoration: none;
            margin-left: 4px;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.modal-footer-custom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    // padding: 10px 20px 16px;

    .cancel-btn,
    .confirm-btn {
        min-width: 78px;
        height: 30px;
        font-size: 12px;
        border-radius: 4px;
    }

    .cancel-btn {
        background: #fff;
        border: 1px solid #dcdee2;
        color: #515a6e;

        &:hover {
            border-color: #4877E8;
            color: #4877E8;
            background: #f5f7fa;
        }
    }

    .confirm-btn {
        background: #4877E8;
        border-color: #4877E8;
        color: #fff;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }

        &:disabled {
            background: #c5c8ce;
            border-color: #c5c8ce;
            color: #fff;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
}
 

.exit-modal-content {
    padding: 30px 40px;

    .exit-instruction {
        font-size: 14px;
        color: #515a6e;
        margin-bottom: 20px;
        line-height: 1.6;

        .company-name {
            color: #4877E8;
            font-weight: 500;
        }
    }

    .exit-reason-input {
        ::v-deep .ivu-input-wrapper {
            textarea {
                font-size: 14px;
                color: #17233d;
                resize: none;
            }
        }

        ::v-deep .ivu-input-word-count {
            color: #808695;
            font-size: 12px;
        }
    }
}

.exit-modal-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    // padding: 10px 20px 16px;

    .cancel-btn,
    .confirm-btn {
        min-width: 78px;
        height: 30px;
        font-size: 12px;
        border-radius: 4px;
    }

    .cancel-btn {
        background: #fff;
        border: 1px solid #dcdee2;
        color: #515a6e;

        &:hover {
            border-color: #4877E8;
            color: #4877E8;
            background: #f5f7fa;
        }
    }

    .confirm-btn {
        background: #4877E8;
        border-color: #4877E8;
        color: #fff;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }

        &:disabled {
            background: #c5c8ce;
            border-color: #c5c8ce;
            color: #fff;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
}
 

.record-modal-content {
    padding: 24px 30px;
    max-height: 600px;
    overflow-y: auto;

    .loading-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 0;
        color: #808695;

        .loading-icon {
            animation: spin 1s linear infinite;
            margin-bottom: 12px;
        }
    }

    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    .empty-record {
        text-align: center;
        padding: 60px 0;
        color: #808695;

        .empty-text {
            font-size: 14px;
            color: #808695;
            margin-top: 16px;
        }
    }

    .record-list {
        max-height: 400px;
        overflow-y: auto;
        .record-item {
            margin-bottom: 20px;
            padding: 20px;
            background: #f8f9fa;
            border-radius: 8px;
            border: 1px solid #e8eaec;
            transition: all 0.2s;

            &:hover {
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            }

            &:last-child {
                margin-bottom: 0;
            }

            .record-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;
                padding-bottom: 12px;
                border-bottom: 1px solid #e8eaec;
                flex-wrap: wrap;
                gap: 12px;

                .record-time {
                    font-size: 14px;
                    color: #515a6e;
                }

                .record-operator {
                    font-size: 14px;
                    color: #515a6e;
                }

                .record-type {
                    font-size: 14px;
                    color: #4877E8;
                    background: #f0f4ff;
                    padding: 4px 12px;
                    border-radius: 4px;
                }
            }

            .record-details {
                .detail-item {
                    margin-bottom: 16px;
                    font-size: 14px;
                    line-height: 1.6;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .detail-label {
                        color: #515a6e;
                        margin-right: 8px;
                    }

                    .detail-value {
                        color: #17233d;
                        font-weight: 500;

                        .old-value {
                            text-decoration: line-through;
                            color: #808695;
                            margin-right: 4px;
                        }

                        .separator {
                            color: #808695;
                            margin: 0 4px;
                        }
                    }
                }
            }
        }
    }

    .pagination-wrapper {
        margin-top: 24px;
        text-align: right;
        padding-top: 16px;
        border-top: 1px solid #e8eaec;
    }
}

.record-modal-footer {
    display: flex;
    justify-content: center;
    padding: 10px 20px 16px;

    .close-btn {
        min-width: 78px;
        height: 30px;
        font-size: 12px;
        border-radius: 4px;
        background: #4877E8;
        border-color: #4877E8;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }
    }
}

 
.auth-modal-content {
    padding: 30px 40px;

    .enterprise-info-section {
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e8eaec;

        .section-title {
            font-size: 16px;
            font-weight: bold;
            color: #17233d;
            margin-bottom: 16px;
        }

        .info-details {
            .info-line {
                margin-bottom: 12px;
                font-size: 14px;

                &:last-child {
                    margin-bottom: 0;
                }

                .info-label {
                    color: #515a6e;
                    margin-right: 8px;
                }

                .info-value {
                    color: #17233d;
                }
            }
        }
    }

    .auth-records-section {
        .section-title {
            font-size: 16px;
            font-weight: bold;
            color: #17233d;
            margin-bottom: 16px;
        }

        .pagination-wrapper {
            margin-top: 20px;
            text-align: right;
        }
    }
}
 
.tip-modal-content {
    padding: 30px 40px;
    display: flex;
    align-items: flex-start;

    .tip-icon-wrapper {
        margin-right: 16px;
        flex-shrink: 0;

        .tip-icon {
            font-size: 32px;
            color: #FF9900;
        }
    }

    .tip-content {
        flex: 1;

        .tip-item {
            font-size: 14px;
            color: #17233d;
            line-height: 1.8;
            margin-bottom: 12px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

.tip-modal-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    // padding: 10px 20px 16px;

    .cancel-btn,
    .confirm-btn {
        min-width: 78px;
        height: 30px;
        font-size: 12px;
        border-radius: 4px;
    }

    .cancel-btn {
        background: #fff;
        border: 1px solid #dcdee2;
        color: #515a6e;

        &:hover {
            border-color: #4877E8;
            color: #4877E8;
            background: #f5f7fa;
        }
    }

    .confirm-btn {
        background: #4877E8;
        border-color: #4877E8;
        color: #fff;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }
    }
}
 

// 企业信息变更表单样式（参考 NotCertified.vue 弹窗2）
.auth-form-content {
    padding: 24px;

    .form-section {
        margin-bottom: 16px;

        .section-title {
            font-size: 14px;
            font-weight: bold;
            color: #17233d;
            margin-bottom: 16px;
        }

        .option-group {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
            padding-left: 36px;

            .option-item {
                min-width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #dcdee2;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.2s;
                color: #515a6e;

                &:hover {
                    border-color: #4877E8;
                    color: #4877E8;
                }

                &.active {
                    border-color: #4877E8;
                    background: #4877E8;
                    color: #fff;
                }
            }
        }

        .auth-period-select {
            width: 240px;
            max-width: 100%;
        }
    }

    .agreement-section {
        margin-top: 24px;
        padding-top: 24px; 

        a {
            color: #4877E8;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.form-modal-content {
    padding: 30px 40px;
    //max-height: 600px;
    overflow-y: auto;

    .form-section {
        margin-bottom: 30px;

        &:last-child {
            margin-bottom: 0;
        }

        .section-label {
            font-size: 15px;
            font-weight: 500;
            color: #17233d;
            margin-bottom: 16px;
        }

        .toggle-buttons {
            display: flex;
            gap: 12px;

            .toggle-btn {
                padding: 8px 24px;
                font-size: 14px;
                color: #4877E8;
                border: 1px solid #4877E8;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.2s;
                background: #fff;

                &:hover {
                    background: #f0f4ff;
                }

                &.active {
                    background: #4877E8;
                    color: #fff;
                }
            }
        }

        ::v-deep .required-item {
            .ivu-form-item-label {
                &:before {
                    content: '*';
                    color: #ed4014;
                    margin-right: 4px;
                }
            }
        }
    }

    .agreement-section {
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #e8eaec;

        ::v-deep .ivu-checkbox-wrapper {
            font-size: 14px;
            color: #17233d;
            line-height: 1.6;

            .agreement-link {
                color: #4877E8;
                text-decoration: none;
                margin: 0 4px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}

.form-modal-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    padding: 10px 20px 16px;

    .cancel-btn,
    .confirm-btn {
        min-width: 78px;
        height: 30px;
        font-size: 12px;
        border-radius: 4px;
    }

    .cancel-btn {
        background: #fff;
        border: 1px solid #4877E8;
        color: #4877E8;

        &:hover {
            background: #f0f4ff;
        }
    }

    .confirm-btn {
        background: #4877E8;
        border-color: #4877E8;
        color: #fff;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }

        &:disabled {
            background: #c5c8ce;
            border-color: #c5c8ce;
            color: #fff;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
}

// 深度选择器：修改iView组件样式（参考 NotCertified.vue）
::v-deep .change-form-modal {
    .ivu-modal {
        top: 8vh;
        padding-bottom: 0;
    }

    .ivu-modal-content {
        border-radius: 12px;
        overflow: hidden;
    }

    .ivu-modal-header {
        padding: 16px 24px;
        border-bottom: 1px solid #eef0f3;

        .ivu-modal-header-inner {
            font-size: 16px;
            font-weight: 600;
            color: #17233d;
        }
    }

    .ivu-modal-body {
        padding: 0;
        max-height: calc(72vh - 52px - 52px); /* 限高，保留 header+footer */
        overflow: auto;
        background: #fff;
    }

    .ivu-modal-footer {
        padding: 14px 24px;
        border-top: 1px solid #eef0f3;
        background: #fff;
    }

    .ivu-form-item {
        margin-bottom: 20px;
    }

    .ivu-form-item-label {
        font-size: 14px;
        color: #515a6e;
    }

    .ivu-input,
    .ivu-select-selection {
        border-color: #dcdee2;
        font-size: 14px;

        &:hover {
            border-color: #4877E8;
        }

        &:focus {
            border-color: #4877E8;
            box-shadow: 0 0 0 2px rgba(72, 119, 232, 0.2);
        }
    }

    .ivu-input-large {
        height: 44px;
        font-size: 16px;
    }

    .ivu-checkbox-wrapper {
        font-size: 14px;
        color: #515a6e;
    }

    .ivu-btn {
        font-size: 14px;
        height: 36px;
        padding: 0 20px;
    }

    /* 营业执照预览区按钮：不跟随弹窗大按钮尺寸 */
    .license-actions .ivu-btn {
        font-size: 12px;
        height: 22px;
        line-height: 20px;
        padding: 0 8px;
        border-radius: 4px;
    }

    .ivu-btn-primary {
        background-color: #4877E8;
        border-color: #4877E8;

        &:hover {
            background-color: #3d6bd8;
            border-color: #3d6bd8;
        }

        &:disabled {
            background-color: #c5c8ce;
            border-color: #c5c8ce;
            opacity: 0.6;
        }
    }
}

// 协议图片弹窗样式
::v-deep .agreement-image-modal {
    .image-view-content {
        padding: 24px;
        max-height: 600px;
        overflow-y: auto;

        .image-list {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .image-item {
                width: 100%;
                text-align: center;

                img {
                    max-width: 100%;
                    height: auto;
                    border: 1px solid #e8eaec;
                    border-radius: 4px;
                }
            }
        }

        .empty-image {
            text-align: center;
            padding: 60px 0;
            color: #808695;

            p {
                margin-top: 16px;
                font-size: 14px;
            }
        }
    }
}

// 详情弹窗样式
.detail-modal-content {
    padding: 24px 0;

    .detail-card {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
        border: 1px solid #e8eaec;

        .detail-item {
            display: flex;
            margin-bottom: 20px;
            align-items: flex-start;

            &:last-child {
                margin-bottom: 0;
            }

            .detail-label {
                min-width: 100px;
                color: #515a6e;
                font-size: 14px;
                font-weight: 500;
                margin-right: 16px;
                flex-shrink: 0;
            }

            .detail-value {
                flex: 1;
                color: #17233d;
                font-size: 14px;
                line-height: 1.6;
                word-break: break-word;

                .status-tag {
                    display: inline-block;
                    padding: 4px 12px;
                    border-radius: 4px;
                    font-size: 13px;
                    font-weight: 500;

                    &.status-pending {
                        background: #fff7e6;
                        color: #ff9900;
                    }

                    &.status-approved {
                        background: #f0f9ff;
                        color: #19be6b;
                    }

                    &.status-rejected {
                        background: #fff1f0;
                        color: #ed4014;
                    }
                }

                &.reason-text,
                &.refuse-text {
                    color: #515a6e;
                    line-height: 1.8;
                    padding: 12px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #e8eaec;
                }

                &.refuse-text {
                    color: #ed4014;
                    background: #fff1f0;
                    border-color: #ffccc7;
                }
            }
        }
    }
}

.detail-modal-footer {
    display: flex;
    justify-content: center;
    padding: 10px 20px 16px;

    .close-btn {
        min-width: 84px;
        height: 32px;
        background: #4877E8;
        border-color: #4877E8;
        font-size: 13px;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }
    }
}

::v-deep .detail-info-modal {
    .ivu-modal-body {
        padding: 24px;
    }
}

/* 认证新企业 Modal：尽量接近全屏 */
::v-deep .new-enterprise-cert-modal {
    top: 10px;
}

::v-deep .new-enterprise-cert-modal .ivu-modal-content {
    max-height: calc(100vh - 20px);
    overflow: auto;
}
</style>
